import { render, staticRenderFns } from "./add_shoplist.vue?vue&type=template&id=ce47f9b8&scoped=true&"
import script from "./add_shoplist.vue?vue&type=script&lang=js&"
export * from "./add_shoplist.vue?vue&type=script&lang=js&"
import style0 from "./add_shoplist.vue?vue&type=style&index=0&id=ce47f9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce47f9b8",
  null
  
)

export default component.exports